export default __webpack_public_path__ + "static/media/creditone.4ef7bfc8.png";